// @flow

import Ajv from 'ajv';
import yaml from 'js-yaml';
import type {MarkdocNodeRegistration} from 'docs/markdoc';
import schema from './SchemaFrontmatter.json';
import type {ValidationMetadata} from '../../../../../manifest/validators/getValidationConfig';

const ajv = new Ajv({allErrors: true});

type AjvError = {|
  keyword: string,
  message: string,
  dataPath: string,
  params: {[key: string]: any},
|};

const renderFrontmatterError = (err: AjvError) => {
  if (err.keyword === 'additionalProperties') {
    err.message = 'invalid property should not exist';
    err.dataPath = [err.dataPath, err.params.additionalProperty].join('/');
  }

  return `(Frontmatter ${err.keyword}) error at ${err.dataPath || '/'}: ${
    err.message
  }`;
};

export const Document: MarkdocNodeRegistration = {
  node: 'document',
  component: 'Document',
  attributes: {
    frontmatter: {type: String, render: false},
  },

  validate(node, config: any) {
    const raw = node.attributes.frontmatter;
    if (typeof raw !== 'string') {
      return [];
    }

    let errors = [];
    const frontmatter: ?{[string]: any} = (yaml.safeLoad(raw): any);

    if (frontmatter) {
      const redirects: ?Array<string> = frontmatter.redirects;
      const validationMetadata: ValidationMetadata = config.validationMetadata;

      if (redirects && redirects.length > 0) {
        const invalidRedirects = redirects.filter((redirect) =>
          validationMetadata.routes.includes(redirect),
        );

        errors = invalidRedirects.map((redirect) => ({
          id: 'frontmatter-redirect-loop',
          level: 'critical',
          message: `redirect ${redirect} causes an infinite redirect loop`,
        }));
      }
    }

    const validFrontmatterSchema = ajv.validate(schema, frontmatter);
    if (validFrontmatterSchema) {
      return errors;
    }

    const frontmatterValidationErrors = ajv.errors.map((err) => ({
      id: 'frontmatter-invalid',
      level: 'critical',
      message: renderFrontmatterError(err),
    }));

    return [...errors, ...frontmatterValidationErrors];
  },
};
